<template>
  <div style="margin:20em">
    <div class="mt-3">
      <h6>Large</h6>
      <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="rows" size="lg">
      </b-pagination>
  </div>

    <p style="text-align: center;margin-bottom: 10px;">Auto Complete Box for {{ $vuetify.lang.t('$vuetify.cui-selected') }}
      {{ $vuetify.lang.t('$vuetify.cui-country') }}
    </p>
    <autocomplete :search="search"></autocomplete>
    <div style="margin-top:2em">
       <p style="text-align: center;margin-bottom: 10px;">{{ $vuetify.lang.t('$vuetify.cui-timezone') }}</p>
      <select
        class="cui-select"
        style="margin-top: -10px;height:auto"
        v-model="selected">
        <option value>---select a timezone---</option>
        <option
          v-for="entry in timezones"
          :key="entry.id"
          :value="entry.id"
        >{{ entry.name }}</option>
      </select>
    </div>
    <div>
  <div class="form-group" :class="{ 'form-group--error': $v.name.$error }">
    <label class="form__label">Name</label>
    <input  class="cui-input" v-model.trim="$v.name.$model"/>
    <div class="cui-error">
            <div class="cui-error__message"
                 v-if="!$v.name.required">
               Field is required
            </div>
            <div class="cui-error__message"
                v-if="!$v.name.minLength">
               Name must have at least {{$v.name.$params.minLength.min}} letters.
            </div>
        </div>
  </div>
</div>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import Countries from '../../plugins/factory/Countries'
import Timezones from '../../plugins/factory/Timezones'
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  components: {
    Autocomplete
  },
  data () {
    return {
      countries: Countries.countries,
      timezones: Timezones.timezones,
      selected: '',
      name: '',
      rows: 1,
      perPage: 10,
      currentPage: 1
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {
    search (input) {
      if (input.length < 1) {
        return []
      }
      return this.countries.filter(country => {
        return country.toLowerCase().startsWith(input.toLowerCase())
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Demo.vue